import { useBranding } from "@app-setup:BrandingContext";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

export const Landing = () => {
  const { t } = useTranslation();
  const { getPageConfig } = useBranding();
  const chatConfig = getPageConfig("chat");
  const greeting = chatConfig?.title || t("chat.greeting");

  return (
    <Box
      sx={{
        position: "relative",
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          sx={{
            marginBottom: "1.25rem",
            fontSize: "1.5rem",
            fontWeight: "bold",
          }}
        >
          {greeting}
        </Typography>
      </Box>
    </Box>
  );
};
